const INITIAL_STATE = {
  data: {},
  summary: {},
  errors: {},
        
}
const getSalesByItem = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'SALES_BY_ITEM_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'SALES_BY_ITEM_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_SALES_TAX_SUMMARY':
    return { ...INITIAL_STATE, summary: action.data }
  case 'GET_SALES_TAX_SUMMARY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default getSalesByItem;